import { IEditorInstanceService } from './editor-instance-service.interface';
import { ISelectionService } from '@src/slide/application/service/selection/selection-service.interface';
import { ITextEditor } from '@src/slide/domain/ui-model/element-modeles/property/text/interface/text-editor.interface';

export class EditorInstanceService implements IEditorInstanceService {
    private selectionService?: ISelectionService;

    public setSelectionServiceDelegate = (selectionService: ISelectionService): void => {
        if (!this.selectionService) {
            this.selectionService = selectionService;
        }
    };

    public getEditorInstance = (): ITextEditor => {
        const selectedModels = this.getSelectedArray();
        if (selectedModels) {
            // 获取正在编辑的 model
            // @ts-ignore
            const editingModel = selectedModels.find(model => model?.editorInstance?.isEditing);
            // 表格和形状上都挂载了 editorInstance
            // @ts-ignore
            return editingModel?.editorInstance;
        }

        // 没有选中的 model 时以备注为准
        const noteInstance = this.selectionService?.currentSlide?.noteData?.noteInstance;
        return noteInstance?.isEditing ? noteInstance.textEditor : null;
    };

    public checkEditorIsEditing(): boolean {
        return !!this.getEditorInstance()?.isEditing ?? false;
    }

    private getSelectedArray = () => this.selectionService?.selectedElements?.selectedArray;
}
